import { type ReactElement } from "react";
import { Stack, LinearProgress } from "@citibox-panel/ui";

export function LinearProgressDemo(): ReactElement {
  return (
    <Stack spacing={2}>
      <LinearProgress value={0} aria-label="Cobertura vacía" />
      <LinearProgress value={87.5} aria-label="Cobertura parcial" />
      <LinearProgress value={100} aria-label="Cobertura completa" />
    </Stack>
  );
}
